module.exports = __webpack_public_path__ + "static/media/ankita_bose.31973cd5.jpg";